/* MoveUrge theme: menu, header, scroll animations, hero video, toast, forms */
(() => {
  document.documentElement.classList.remove("no-js");
  const MU = (window.MU = window.MU || {});
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Header turns solid after scrolling on the homepage */
  const header = document.getElementById("site-header");
  if (header && MU.page === "index") {
    const onScroll = () => header.classList.toggle("is-solid", window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Mobile menu */
  const menu = document.getElementById("mobile-menu");
  const menuBtn = document.querySelector("[data-open-menu]");
  if (menu && menuBtn) {
    const setMenu = (open) => {
      menu.classList.toggle("is-open", open);
      menu.setAttribute("aria-hidden", String(!open));
      menuBtn.setAttribute("aria-expanded", String(open));
      document.body.classList.toggle("lock", open);
      if (open) menu.querySelector("[data-close-menu]").focus();
      else menuBtn.focus();
    };
    menuBtn.addEventListener("click", () => setMenu(true));
    menu.querySelectorAll("[data-close-menu]").forEach((b) => b.addEventListener("click", () => setMenu(false)));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && menu.classList.contains("is-open")) setMenu(false); });
  }

  /* Scroll reveal */
  MU.observeReveals = (root = document) => {
    const els = root.querySelectorAll(".reveal:not(.is-in)");
    if (reduceMotion || !("IntersectionObserver" in window) || window.Shopify?.designMode) {
      els.forEach((el) => el.classList.add("is-in"));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach((el) => io.observe(el));
  };
  const stagger = (root = document) => root.querySelectorAll("[data-stagger]").forEach((group) => {
    group.querySelectorAll(":scope > .reveal").forEach((el, i) => { el.style.transitionDelay = `${i * 70}ms`; });
  });
  stagger();
  MU.observeReveals();
  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener("shopify:section:load", (e) => { stagger(e.target); MU.observeReveals(e.target); initVideo(e.target); });

  /* Hero video play/pause */
  function initVideo(root = document) {
    const video = root.querySelector(".hero video");
    const btn = root.querySelector(".video-toggle");
    if (!video || !btn) return;
    const pause = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>';
    const play = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5l12 7-12 7z"/></svg>';
    const sync = () => {
      btn.innerHTML = video.paused ? play : pause;
      btn.setAttribute("aria-label", video.paused ? "Play video" : "Pause video");
    };
    if (reduceMotion) video.pause(); else video.play().catch(() => {});
    video.addEventListener("play", sync);
    video.addEventListener("pause", sync);
    btn.addEventListener("click", () => (video.paused ? video.play() : video.pause()));
    sync();
  }
  initVideo();

  /* Toast */
  let timer;
  MU.toast = (msg) => {
    const t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(timer);
    timer = setTimeout(() => t.classList.remove("is-on"), 3200);
  };

  /* Email signup: friendly check before Shopify's form submits */
  document.querySelectorAll("form[data-signup]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      const input = form.querySelector('input[type="email"]');
      if (!input.value || !input.checkValidity()) {
        e.preventDefault();
        input.focus();
        MU.toast("Enter a valid email to join the crew.");
      }
    });
  });
})();
